import React from "react";
import blueArrow from '../images/blueArrow.gif'
import btnHome from '../images/btnHomeIcon.png'

const Reason = () => {
  return (
    <div className="topicSection">

      {/* HOME BUTTON SECTION */}
      <div className="btnHomeSection bounce-in-fwd10">
        <button type="button" className="btnCircle">
          <img src={btnHome} alt="Date" height="50" width="50" /><br />
          HOME
        </button>
      </div>

      <div className="headerSub">
        <div className="headerSubTitle scale-in-center">
          <p>
            PLEASE SELECT YOUR REASON FOR YOUR PRESENCE
          </p>
        </div>
      </div>

      <div className="headerName">
        <div className="headerTitle">
          {/* <h1>
            <div className="iconWard"></div>
            WARD VISIT
            </h1> */}
        </div>
      </div>


      {/* MAIN CONTENT SECTION */}
      <div className="contentPage">

        
        {/* BUTTON OPTIONS */}
        <div className="optionSection">
          <br/><br/>
          <button type="button" className="btnslanted spaceTopBtm fade-in-leftBtn3">
            Registration
          </button>
          <br />
          <button type="button" className="btnslanted spaceTopBtm fade-in-leftBtn4">
            Return Card
          </button>

          {/* <button type="button" className="btnslanted spaceTopBtm fade-in-leftBtn5">
                Accompanying Patient for Appointment 
            </button>  */}
        </div>



        {/* ICON BOX */}
        <div className="iconSection2 iconCenter flip-in-hor-top2">
          <img className="fade-in3" src={blueArrow} alt="choose" height="600" width="600" />
        </div>

      </div>

    </div>
  );
};

export default Reason;